export const getFullUrl = (path: string): string => {
    const origin = window?.location?.origin ?? '';

    return `${origin}${path}`;
};
